import { decryptJSON } from "../components/service/Encrtyption";

const truthy = (value) =>
  value === true ||
  value === "true" ||
  value === "1" ||
  value === 1;

export const resolveFcMobileNumber = (data) => {
  if (!data || typeof data !== "object") return "";
  const value =
    data.mobileNumber ?? data.mobile ?? data.mbn ?? data.phoneNumber ?? "";
  return String(value).trim();
};

export const resolveFcCustomerId = (data) => {
  if (!data || typeof data !== "object") return "";
  const value = data.customerId ?? data.cid ?? "";
  return String(value).trim();
};

export const resolveFcFarmerName = (data) => {
  console.log(JSON.stringify(data));
  if (!data || typeof data !== "object") return "";
  const value = data.customerName ?? data.name ?? "";
  return String(value).trim();
};

/** Prefer fresh ufromFc from URL over cached session payload. */
export const getUfromFcRaw = (searchParams) => {
  const fromUrl = searchParams?.get?.("ufromFc");
  if (fromUrl) {
    return { raw: fromUrl, isFreshLink: true };
  }
  return {
    raw: sessionStorage.getItem("ufromFcPayload"),
    isFreshLink: false,
  };
};

/**
 * Decode ufromFc query value (AES-encrypted JSON or standard base64 JSON).
 */
export const parseUfromFcParam = (raw) => {
  if (!raw) return null;

  const decoded = decodeURIComponent(String(raw).trim());
  let jsonString = null;

  const aesDecrypted = decryptJSON(decoded);
  if (aesDecrypted) {
    try {
      JSON.parse(aesDecrypted);
      jsonString = aesDecrypted;
    } catch {
      jsonString = null;
    }
  }

  if (!jsonString) {
    try {
      const normalized = decoded.replace(/-/g, "+").replace(/_/g, "/");
      const pad = normalized.length % 4;
      const padded =
        pad === 0 ? normalized : normalized + "=".repeat(4 - pad);
      jsonString = atob(padded);
    } catch {
      return null;
    }
  }

  try {
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
};

export const isFcAutoVerifyEligible = (data) =>
  Boolean(data) &&
  truthy(data.otpVerified) &&
  Boolean(resolveFcMobileNumber(data)) &&
  Boolean(data.completeUrl || data.coidurl || data.coidUrl || data.url);

export const buildFcGenuityPayload = (data, appLangCode) => {
  const completeUrl =
    data.completeUrl || data.coidurl || data.coidUrl || data.url || "";

  return {
    completeUrl,
    mobileNumber: resolveFcMobileNumber(data),
    customerId: resolveFcCustomerId(data),
    otp: data.otp || "",
    otpVerified: true,
    deviceType: data.deviceType || "WEB",
    deviceId: data.deviceId || "",
    countryId: data.countryId ?? 5,
    state: data.state ?? "",
    district: data.district ?? "",
    pincode: data.pincode ?? "",
    destinationURL:
      data.destinationURL || "/customer/saveGenuinityCheckDetails_V2_acviss",
    token: data.token ?? "",
    prunningFlag: data.prunningFlag ?? data.pruningFlag ?? "",
    isZCZCRegister:
      data.isZCZCRegister === true ||
      data.isZCZCRegister === "true" ||
      Boolean(data.isZCZCRegister),
    moduleType:
      data.moduleType ||
      data.product ||
      sessionStorage.getItem("storedProductName") ||
      "strongarm",
    appLangCode,
  };
};

export const persistFcSession = (data, { isFreshLink = false } = {}) => {
  const mobile = resolveFcMobileNumber(data);
  if (mobile) {
    sessionStorage.setItem("mbn", mobile);
  } else if (isFreshLink) {
    sessionStorage.removeItem("mbn");
  }
  const customerId = resolveFcCustomerId(data);
  if (customerId) {
    sessionStorage.setItem("cid", customerId);
  } else if (isFreshLink) {
    sessionStorage.removeItem("cid");
  }

  const name = resolveFcFarmerName(data);
  if (name) {
    sessionStorage.setItem("name", name);
  } else if (isFreshLink) {
    sessionStorage.removeItem("name");
  }

  const product = data.product || data.moduleType;
  if (product) {
    sessionStorage.setItem("storedProductName", String(product).toLowerCase());
  }
};
